import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import { useMsal } from "@azure/msal-react";
import { useIdToken } from "../hooks/useLogin";
interface IIsAuthenticated {
  children?: React.ReactNode
}

const IsAuthenticated: React.FC<IIsAuthenticated> = ({ children }) => {
  const navigate = useNavigate()
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { getToken } = useIdToken()

  useEffect(() => {
    getToken()
  }, [])

  useEffect(() => {
    if (!isAuthenticated && inProgress === "none" )
      navigate('/')
  }, [isAuthenticated, navigate, inProgress])

  // if (inProgress !== 'none') return <></>
  return (
    <>{inProgress === 'none' && isAuthenticated && children}</>
  );
};

export default IsAuthenticated;
